import React from "react";

import CssBaseline from "@busbud/design-system-components/dist/CssBaseline";
import Grid from "@busbud/design-system-components/dist/Grid";
import Layout from "@busbud/design-system-components/dist/Layout";
import LayoutSection from "@busbud/design-system-components/dist/Layout/LayoutSection";

import { useStyles } from "./basic-layout.styles";

export const BasicLayout: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { classes } = useStyles();

  return (
    <>
      <CssBaseline />
      <Layout className={classes.layoutRoot}>
        <LayoutSection>
          <Grid container justifyContent="center" className={classes.grid}>
            <Grid item xs={24} md={12}>
              {children}
            </Grid>
          </Grid>
        </LayoutSection>
      </Layout>
    </>
  );
};
